import { FC } from 'react';
import { Row } from '@tanstack/react-table';
import { RiArrowRightSFill, RiArrowDownSFill } from 'react-icons/ri';
import strings from '../shared.translations';

interface TableExpanderProps {
  row: Row<any>;
}

export const TableExpander: FC<TableExpanderProps> = ({ row }) => {
  const iconStyle = 'h-7 w-7';
  const label = strings.table.rowExpandLabel;

  return (
    <span onClick={row.getToggleExpandedHandler()} className="cursor-pointer">
      <button aria-label={label} type="button" className="pointer-events-none">
        {row.getIsExpanded() ? <RiArrowDownSFill className={iconStyle} /> : <RiArrowRightSFill className={iconStyle} />}
      </button>
    </span>
  );
};
